module.exports = __webpack_public_path__ + "img/file-xl.c81476d4.svg";